import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';

// import Typography from '@mui/material/Typography'; // TODO: Descomentar cuando se reactive el filtro de fechas

import Button from '@/components/Button';
import GenericFilters from '@/components/GenericFilters';

// import RangeDatePicker from '@/components/RangeDatePicker/RangeDatePicker'; // TODO: Descomentar cuando se reactive el filtro de fechas

import { FilterSection } from '../../OrderStatus/Table/utils';
import { IInventoryHistoryFilters } from './useInventoryHistory';

interface InventoryHistoryFiltersProps {
  selectedFilters: IInventoryHistoryFilters;
  onChange: (filterName: string, value: string) => void;
  clearFilters?: () => void;
  applyFilters?: () => void;
  filters: FilterSection[];
  isClearPending?: boolean;
  isApplyPending?: boolean;
}

const InventoryHistoryFilters = ({
  filters,
  selectedFilters,
  onChange,
  clearFilters,
  applyFilters,
  isClearPending = false,
  isApplyPending = false,
}: InventoryHistoryFiltersProps) => {
  const theme = useTheme();

  const transformedFilters: Record<string, string | string[]> = Object.entries(selectedFilters)
    .filter(([, value]) => value !== undefined)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  const commonPaperStyle = {
    p: 2.5,
    mb: 2,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'background.paper',
  };

  return (
    <Box sx={{ mt: 2, maxWidth: '100%', overflow: 'hidden' }}>
      <Paper elevation={0} sx={commonPaperStyle}>
        <GenericFilters
          filters={filters}
          selectedFilters={transformedFilters}
          handleOnChange={onChange}
          typeCheck="radio"
        />
      </Paper>

      {/* TODO: Descomentar cuando el backend esté listo para filtros de fecha */}
      {/* <Box mt="2rem">
        <Typography 
          variant="h6" 
          fontWeight={theme.typography.fontWeightMedium}
          mb="1rem"
          sx={{ color: theme.palette.text.primary }}
        >
          Rango de Fechas
        </Typography>
        <RangeDatePicker
          startLabel="Fecha de inicio"
          endLabel="Fecha de fin"
          onChange={onChange}
          untilToday={true}
          startValue={selectedFilters.startDate}
          endValue={selectedFilters.endDate}
        />
      </Box> */}

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          '& > button': {
            minWidth: '140px',
            px: 3,
            py: 1,
            [theme.breakpoints.down('sm')]: { width: '100%' },
          },
        }}
      >
        <Button onClick={clearFilters} variant="outlined" disabled={isClearPending}>
          {isClearPending ? (
            <CircularProgress size={20} sx={{ color: '#4caf50' }} />
          ) : (
            'Limpiar filtros'
          )}
        </Button>
        <Button onClick={applyFilters} variant="contained" disabled={isApplyPending}>
          {isApplyPending ? (
            <CircularProgress size={20} sx={{ color: '#4caf50' }} />
          ) : (
            'Aplicar filtros'
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default InventoryHistoryFilters;
